export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看信息',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    divided: true,
    disabled: false
  },
  {
    text: that.$l('btn_unsaleable') || '不可售',
    icon: 'el-icon-shopping-cart-2',
    menuType: 'unsaleable',
    divided: true,
    allow: 'N',
    disabled: ({ storeSkuStatus }) => {
      return !['Y'].includes(storeSkuStatus)
    },
  },
  {
    text: that.$l('btn_availableSale') || '可售',
    icon: 'el-icon-shopping-cart-full',
    menuType: 'availableSale',
    divided: false,
    allow: 'S',
    disabled: ({ storeSkuStatus }) => {
      return !['S'].includes(storeSkuStatus)
    },
  },
  {
    text: that.$l('btn_view_noRestocking') || '不补货',
    icon: 'el-icon-circle-close',
    menuType: 'noRestocking',
    divided: true,
    allow: 'B',
    disabled: ({ noMoreReplenishment }) => {
      return !['N'].includes(noMoreReplenishment)
    },
  },
  {
    text: that.$l('btn_view_restocking') || '可补货',
    icon: 'el-icon-circle-check',
    menuType: 'restocking',
    divided: false,
    allow: 'R',
    disabled: ({ noMoreReplenishment }) => {
      return !['Y'].includes(noMoreReplenishment)
    },
  },
]
